// Based on the approach described here: https://stackoverflow.com/a/49579497
export function expectTrue() {}
export function expectFalse() {}
expectTrue();
expectTrue();
expectTrue();
expectFalse();
expectFalse();
expectFalse();
expectFalse();
expectFalse();
expectTrue();
expectFalse();
expectTrue();
expectFalse();
expectTrue();
expectFalse();
expectTrue();
expectFalse();